import supabase from '../supabaseClient/supabaseClient';
export { supabase };
export const apiBase=process.env.REACT_APP_BE_URL;
export const peerOrigin=process.env.REACT_APP_QUIZ_ORIGIN || 'https://quiz.theworksheep.com';
export const defaultPath='/create';

export const appName='Worksheets';
export const peerName='Quiz Builder';
